import { Injectable, inject, ErrorHandler } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

/** Mensaje que ve el usuario ante un error del servidor (5xx) en producción */
export const SERVER_ERROR_MESSAGE =
  'Ocurrió un error inesperado en el servidor. Inténtalo nuevamente; si el problema persiste, comunícate con soporte.';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private errorHandler = inject(ErrorHandler);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(

      catchError((error: any) => {
        if (error instanceof HttpErrorResponse) {
          error = this.hideServerDetails(error);
          this.errorHandler.handleError(error);
        } else {
          this.errorHandler.handleError(error);
        }
        return throwError(() => error);
      })
    );
  }

  /**
   * En producción, un error 5xx puede traer detalles técnicos (consultas SQL, tablas, datos):
   * varios controladores devuelven el mensaje de la excepción tal cual. Se reemplaza por un mensaje
   * genérico antes de que llegue al manejador global o a cualquier componente.
   * En desarrollo se deja el detalle para depurar.
   */
  private hideServerDetails(error: HttpErrorResponse): HttpErrorResponse {
    if (!environment.production || error.status < 500) { //si el entorno de desarrollo es local
      return error;
    }

    //si el entorno de desarrollo es produccion
    const body = typeof error.error === 'object' && error.error !== null ? error.error : {};
    return new HttpErrorResponse({
      error: { ready: false, message: SERVER_ERROR_MESSAGE, code: body.code ?? error.status },
      headers: error.headers,
      status: error.status,
      statusText: error.statusText,
      url: error.url ?? undefined,
    });
  }
}
